import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import PreviewTable from "../../../components/PreviewTable";
import { rightAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";

const { Text, Title } = Typography;
const { TextArea } = Input;

function NewChequeDeposit(props) {
  const { userData } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState(null);
  const [accountData, setAccountData] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [toClientOptions, setToClientOptions] = useState([]);
  const [toAccountOptions, setToAccountOptions] = useState([]);
  const [toAccountTypeOptions, setToAccountTypeOptions] = useState([]);
  const [toOfficeDetail, setToOfficeDetail] = useState(null);
  const [toClientDetail, setToClientDetail] = useState(null);
  const [toAccountDetail, setToAccountDetail] = useState(null);
  const [toAccountTypeDetail, setToAccountTypeDetail] = useState(null);
  const [fromOfficeId, setFromOfficeId] = useState(null);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);

  const [accountId, setAccountId] = useState("");

  const searchParam = Form.useWatch("accountNo", form);
  const paymentType = Form.useWatch("paymentType", form);

  const dataSections = [
    {
      name: "Name",
      labelValue: searchData?.name || "----",
    },
    {
      name: "Branch",
      labelValue: searchData?.branch || "----",
    },
    {
      name: "From Account",
      labelValue: searchData?.fromAccount || "----",
    },
    {
      name: "From Account Type",
      labelValue: searchData?.fromAccountType || "----",
    },
    {
      name: "Currency",
      labelValue: searchData?.currency || "----",
    },
  ];

  useEffect(() => {
    getPaymentTypes();
  }, []);

  const getPaymentTypes = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.PaymentTypes}`;

    setLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        let tempPaymentTypeOptions = [];

        objList?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        setPaymentTypeOptions(tempPaymentTypeOptions);
        setLoading(false);
      }
    });
  };

  const getTemplate = (res) => {
    const params = {
      fromAccountId: res.id,
      fromAccountType: 2,
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.TransferFund}/template`;

    setLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        let tempBranchOptions = [];
        let tempToAccountTypeOptions = [];

        objList?.toOfficeOptions?.forEach((element) => {
          tempBranchOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objList?.toAccountTypeOptions?.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        setFromOfficeId(objList?.fromOffice?.id);
        setBranchOptions(tempBranchOptions);
        setToAccountTypeOptions(tempToAccountTypeOptions);
        setLoading(false);
      }
    });
  };

  const getToOfficeIdTemplate = (toOfficeParam) => {
    const params = {
      fromAccountId: accountId,
      fromAccountType: 2,
      toOfficeId: toOfficeParam,
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.TransferFund}/template`;

    setLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        let tempBranchOptions = [];
        let tempToAccountTypeOptions = [];
        let tempToClientOptions = [];

        objList?.toOfficeOptions?.forEach((element) => {
          tempBranchOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objList?.toAccountTypeOptions?.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objList?.toClientOptions?.forEach((element) => {
          tempToClientOptions.push({
            value: element?.id,
            label: `${element?.id} - ${element?.displayName}`,
          });
        });

        setBranchOptions(tempBranchOptions);
        setToAccountTypeOptions(tempToAccountTypeOptions);
        setToClientOptions(tempToClientOptions);
        setLoading(false);
      }
    });
  };

  const getToClientTemplate = (toClientParam) => {
    const params = {
      fromAccountId: accountId,
      fromAccountType: 2,
      toOfficeId: toOfficeDetail,
      toClientId: toClientParam,
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.TransferFund}/template`;

    setLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        let tempBranchOptions = [];
        let tempToAccountTypeOptions = [];
        let tempToClientOptions = [];

        objList?.toOfficeOptions?.forEach((element) => {
          tempBranchOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objList?.toAccountTypeOptions?.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objList?.toClientOptions?.forEach((element) => {
          tempToClientOptions.push({
            value: element?.id,
            label: `${element?.id} - ${element?.displayName}`,
          });
        });

        setBranchOptions(tempBranchOptions);
        setToAccountTypeOptions(tempToAccountTypeOptions);
        setToClientOptions(tempToClientOptions);

        setLoading(false);
      }
    });
  };

  const getToAccountTypeTemplate = (toAccountTypeParam) => {
    const params = {
      fromAccountId: accountId,
      fromAccountType: 2,
      toOfficeId: toOfficeDetail,
      toClientId: toClientDetail,
      toAccountType: toAccountTypeParam,
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.TransferFund}/template`;

    setLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        let tempBranchOptions = [];
        let tempToAccountTypeOptions = [];
        let tempToAccountOptions = [];
        let tempToClientOptions = [];

        objList?.toOfficeOptions?.forEach((element) => {
          tempBranchOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objList?.toAccountTypeOptions?.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objList?.toAccountOptions?.forEach((element) => {
          tempToAccountOptions.push({
            value: element?.id,
            label: `${element?.productName} - ${element?.currency?.code} - ${element?.accountNo}`,
          });
        });

        objList?.toClientOptions?.forEach((element) => {
          tempToClientOptions.push({
            value: element?.id,
            label: `${element?.id} - ${element?.displayName}`,
          });
        });

        setBranchOptions(tempBranchOptions);
        setToAccountTypeOptions(tempToAccountTypeOptions);
        setToAccountOptions(tempToAccountOptions);
        setToClientOptions(tempToClientOptions);
        setLoading(false);
      }
    });
  };

  const getToAccountTemplate = (toAccountParam) => {
    const params = {
      fromAccountId: accountId,
      fromAccountType: 2,
      toOfficeId: toOfficeDetail,
      toClientId: toClientDetail,
      toAccountType: toAccountTypeDetail,
      paymentTypeId: paymentType,
      toAccountId: toAccountParam,
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.TransferFund}/template`;

    setLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        let tempBranchOptions = [];
        let tempToAccountTypeOptions = [];
        let tempToClientOptions = [];

        objList?.toOfficeOptions?.forEach((element) => {
          tempBranchOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objList?.toAccountTypeOptions?.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objList?.toClientOptions?.forEach((element) => {
          tempToClientOptions.push({
            value: element?.id,
            label: `${element?.id} - ${element?.displayName}`,
          });
        });

        setBranchOptions(tempBranchOptions);
        setToAccountTypeOptions(tempToAccountTypeOptions);
        setToClientOptions(tempToClientOptions);
        setLoading(false);
      }
    });
  };

  const onChangeToOFfice = (toOfficeParam) => {
    setToOfficeDetail(toOfficeParam);
    getToOfficeIdTemplate(toOfficeParam);
    form.setFieldValue("toClientId", null);
    setToClientDetail(null);
  };

  const onChangeToClient = (toClientParam) => {
    setToClientDetail(toClientParam);
    getToClientTemplate(toClientParam);
  };

  const onChangeToAccountType = (toAccountTypeParam) => {
    setToAccountTypeDetail(toAccountTypeParam);
    getToAccountTypeTemplate(toAccountTypeParam);
  };

  const onChangeToAccount = (toAccountParam) => {
    setToAccountDetail(toAccountParam);
    getToAccountTemplate(toAccountParam);
  };

  function getAccountDetails(accountNo) {
    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }

    setLoading(true);
    const url = `${apiConfig.savingsAccountsTeller}/account/${accountNo}?associations=all`;

    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
        setLoading(false);
      } else {
        getTemplate(res);
        const objList = res;

        setSearchData({
          name: objList?.clientName ? objList?.clientName : "",
          branch: objList?.officeName ? objList?.officeName : "",
          fromAccount: objList?.accountNo ? objList?.accountNo : "",
          fromAccountType: objList?.depositType
            ? objList?.depositType?.value
            : "",
          currency: objList?.currency ? objList?.currency?.displayLabel : "",
        });

        setAccountId(objList?.id);
        setAccountData(objList);
        setLoading(false);

        if (searchData === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setLoading(false);
          return;
        }
      }
    });
  }

  const onSubmit = (values) => {
    const payload = {
      fromAccountId: accountId,
      chequeNo: values?.chequeNo,
      fromAccountType: 2,
      fromClientId: accountData?.clientId,
      fromOfficeId: fromOfficeId,
      toOfficeId: toOfficeDetail,
      toClientId: toClientDetail,
      toAccountType: toAccountTypeDetail,
      toAccountId: toAccountDetail,
      paymentTypeId: paymentType,
      transferAmount: values?.transferAmount,
      transferDate: BOM.DateTime(values?.transferDate, "only-date"),
      transferDescription: values?.transferDescription,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setLoading(true);

    const url = `${apiConfig.Cheques}/chequeleaves/deposit`;
    BOM.FetchReqAction(payload, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Cheque deposited successfully");
        form.resetFields();
        setLoading(false);
      }
    });
  };

  const onSearch = () => {
    getAccountDetails(searchParam);
  };

  return (
    <MainLayout
      isEnableRightSidebar={false}
      pageItems={staticConfig.newChequeDepositItems}
    >
      <TopContent pageTitle={labelConfig.newChequeDeposit} />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={loading}>
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Title level={5}>Transfering From Details</Title>
            <Row style={{ marginBottom: 24 }}>
              <Col span={12}>
                <Form.Item
                  label={labelConfig.accountNo}
                  name="accountNo"
                  style={{ marginBottom: 0 }}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.accountNo,
                      )}
                      style={{ height: 44 }}
                      onPressEnter={(e) => {
                        e.preventDefault();
                        onSearch();
                      }}
                      allowClear
                    />
                    <Button
                      htmlType="button"
                      className="of-primaryBtnColor"
                      onClick={onSearch}
                      style={{ height: 44 }}
                    >
                      <SearchOutlined />
                    </Button>
                  </Space.Compact>
                </Form.Item>
              </Col>
            </Row>

            {searchData && (
              <Col span={24} style={{ marginBottom: 30 }}>
                <PreviewTable data={dataSections} />
              </Col>
            )}

            <Divider style={{ marginTop: 10 }} />
            <Title level={5}>Transferring To</Title>
            <Row style={{ marginBottom: 12 }} gutter={12}>
              <Col span={8}>
                <Form.Item
                  label={labelConfig.chequeNumber}
                  name="chequeNo"
                  style={{ marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Cheque Number is required",
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.chequeNumber,
                    )}
                    style={{ width: "100%", height: 44 }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="branch"
                  label={<Text strong>Branch</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Branch is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Branch"
                    options={branchOptions}
                    onChange={onChangeToOFfice}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="client"
                  label={<Text strong>Client</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Client is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Enter Client Name or ID"
                    showSearch
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    options={toClientOptions}
                    onChange={onChangeToClient}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="accountType"
                  label={<Text strong>Account Type</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Account type is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Account Type"
                    options={toAccountTypeOptions}
                    onChange={onChangeToAccountType}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="paymentType"
                  label={<Text strong>Payment Type</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Payment type is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Payment Type"
                    options={paymentTypeOptions}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="account"
                  label={<Text strong>Account</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Account is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Select Account"
                    options={toAccountOptions}
                    onChange={onChangeToAccount}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="transferAmount"
                  label={<Text strong>Amount</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Amount is required",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Enter Amount"
                    className="of-bold-disable-input"
                    formatter={(v) =>
                      `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(v) => v?.replace(/,/g, "")}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="transferDate"
                  label={<Text strong>Transaction Date</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Transaction Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="Select date"
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="transferDescription"
                  label={<Text strong>Description</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Description is required",
                    },
                  ]}
                >
                  <TextArea
                    style={{ height: 88, resize: "none" }}
                    placeholder="Enter description"
                    className="of-bold-disable-input"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row style={{ marginTop: 24 }}>
              <Button
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                className="of-primaryBtnColor"
              >
                Submit
              </Button>
            </Row>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(NewChequeDeposit);
